export default "__VITE_ASSET__DGUsSyMJ__"